// npm install jweixin-module
var jweixin = require('jweixin-module')
import request from '@/common/request'
// 避免ios获取不到url
function getSignUrl() {
	var signLink = ''
	var ua = navigator.userAgent.toLowerCase();
	if (/iphone|ipad|ipod/.test(ua)) {
		signLink = uni.getStorageSync('WxCodeUrl');
		if (!signLink) signLink = location.href
	} else {
		signLink = location.href
	}
	return signLink;
}

function WXConfig(_this) {
	//这个URL 路径中不可以带有hash值 即不能又 #后面的的内容（包含#）
	//这里使用到了encodeURIComponent() 
	const sign_url = getSignUrl().split('#')[0];
	//const sign_url ='https://192.168.0.104:8080'
	let URL = sign_url//window.encodeURIComponent(sign_url)
	const share_url = location.origin
	request.get("/wx/jsapi/wxe6c4e8ada8ee3ae8/getJsapiTicket", {
		url: URL
	}).then((res) => {
		if (res.success) {
			jweixin.config({ //这里是个函数，非对象
				debug: false, // 调试，发布的时候改为false
				appId: res.result.appId, //后端接口获取
				nonceStr: res.result.nonceStr, //后端接口获取
				timestamp: res.result.timestamp, //后端接口获取
				signature: res.result.signature, //后端接口获取
				jsApiList: [ // 可能需要用到的能力 需要啥就写啥。多写也没有坏处
					'updateAppMessageShareData',
					'updateTimelineShareData',
					'onMenuShareAppMessage',
					'onMenuShareTimeline',
					'openLocation'
				]
			})
			let configComnSv =  uni.getStorageSync('configComn') ?  uni.getStorageSync('configComn') : {};
			let link_change = getSignUrl();
			let obj = {
				title: configComnSv.share_title ? configComnSv.share_title : '标题', // 分享标题
				desc: configComnSv.share_desc ? configComnSv.share_desc : '描述', // 分享描述
				// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				link: configComnSv.share_url ? configComnSv.share_url : share_url, //这里可带参数，必须是同配置的JS安全域名一致
				imgUrl: configComnSv.share_pic ? configComnSv.share_pic : '', // 必须是同配置的JS安全域名一致
				success: function() {}
			}
			jweixin.ready(function() {
				if (jweixin.updateAppMessageShareData) {
					jweixin.updateAppMessageShareData(obj); //1.4 分享到朋友
					jweixin.updateTimelineShareData(obj); //1.4分享到朋友圈
				} else {
					jweixin.onMenuShareAppMessage(obj); //1.0 分享到朋友
					jweixin.onMenuShareTimeline(obj); //1.0分享到朋友圈
				}
			})
		}
	})
}

function wxPayConfig(payInfo,url,backfun) {
	jweixin.config({
		debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来,线上环境需要改为false
		appId: payInfo.appId, // 必填，公众号的唯一标识
		timestamp: payInfo.timeStamp, // 必填，生成签名的时间戳
		nonceStr: payInfo.nonceStr, // 必填，生成签名的随机串
		signature: payInfo.paySign, // 必填，签名
		jsApiList: ['chooseWXPay'], // 必填，需要使用的JS接口列表	
	});
	jweixin.ready(() => {
		jweixin.chooseWXPay({
			appId: payInfo.appId, // 必填，公众号的唯一标识
			timestamp: payInfo.timeStamp,
			nonceStr: payInfo.nonceStr, // 支付签名随机串，不长于 32 位
			package: payInfo.packageValue, // 统一支付接口返回的prepay_id参数值
			signType: payInfo.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
			paySign: payInfo.paySign, // 支付签名
			success: function(res) { //支付成功回调
				uni.showToast({
					title: '支付成功',
					icon: 'none',
					duration: 2000,
				})
				// //成功后跳转到订单页
				setTimeout(function() {
					
					uni.navigateTo({
						url: url
					});
				}, 2000)
			},
			cancel: function(res) {
				if(backfun){
					backfun();
				}
				uni.showToast({
					title: '取消支付！',
					icon: 'none',
					duration: 2000,
				})
			},
			fail: function(res) {
				if(backfun){
					backfun();
				}
				uni.showToast({
					title: '支付失败',
					icon: 'none',
					duration: 2000,
				})
			}
		});
	});
	
}
export default {
	WXConfig,wxPayConfig
}
